import React from "react";
import SEO from "../../components/SEO.jsx";
import ProposalPage from "../../components/proposals/ProposalPage.jsx";
import { jmdsProposal } from "../../data/proposals/jmdsProposal.js";
import "../../styles/proposals.css";

export default function JmdsProposalPage() {
  return (
    <>
      <SEO
        title={jmdsProposal.meta.title}
        description={jmdsProposal.hero.intro}
        path="/proposal/jmds"
      />
      <ProposalPage proposal={jmdsProposal} />
    </>
  );
}
